import { useEffect } from 'react';
import api from '../services/api';

// Convierte la clave VAPID pública de base64 a Uint8Array
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map(char => char.charCodeAt(0)));
}

export function usePushNotifications(user) {
  useEffect(() => {
    if (!user) return;
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;

    async function subscribe() {
      try {
        // Registrar el service worker
        const registration = await navigator.serviceWorker.register('/service-worker.js');

        // Si el Service Worker cambió (nueva versión activada), recargar la app una sola vez
        if (!window.__swRefreshing) {
          window.__swRefreshing = true;
          navigator.serviceWorker.addEventListener('controllerchange', () => {
            window.location.reload();
          });
        }

        // Pedir permiso al usuario
        const permission = await Notification.requestPermission();
        if (permission !== 'granted') return;

        // Obtener la clave pública VAPID del backend
        const { data } = await api.get('/push/vapid-public-key');
        const applicationServerKey = urlBase64ToUint8Array(data.publicKey);

        // Suscribirse
        const subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey
        });

        // Enviar la suscripción al backend
        await api.post('/push/subscribe', subscription.toJSON());
      } catch (err) {
        console.error('Error al suscribirse a notificaciones push:', err);
      }
    }

    subscribe();
  }, [user]);
}
